export class Container {
    constructor() {
        this.factories = new Map();
        this.values = new Map();
        this.deps = new Set();
    }
    static get(token) {
        return this.instance.get(token);
    }
    get(token) {
        if (this.deps.has(token)) {
            throw new Error(`circular dependency: ${[...this.deps, token].join(' -> ')}`);
        }
        this.deps.add(token);
        if (this.values.has(token)) {
            this.deps = new Set();
            return this.values.get(token);
        }
        if (this.factories.has(token)) {
            const value = this.build(this.factories.get(token));
            this.values.set(token, value);
            this.deps = new Set();
            return value;
        }
        throw new Error(`cannot find provider ${token}.`);
    }
    static add(provider) {
        return this.instance.add(provider);
    }
    add(provider) {
        if (typeof provider === 'function') {
            this.factories.set(provider, provider);
        }
        else {
            this.factories.set(provider.name, provider);
        }
    }
    build(provider) {
        if (typeof provider === 'function') {
            return new provider(this);
        }
        return provider.factory(this);
    }
}
Container.instance = new Container();
export class Service {
    constructor(ctx) {
        this.ctx = ctx;
    }
}
